import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';
import { withStyles } from '@material-ui/styles';
import styles, { durationEnd } from './styles';

const Background = ({ classes }) => (
  <div className={classes.background}>
    <CSSTransitionGroup
      transitionName={{
        appear: classes.topAppear,
        appearActive: classes.topAppearActive,
      }}
      transitionAppearTimeout={durationEnd}
      transitionAppear
    >
      <div className={classes.top} />
    </CSSTransitionGroup>

    <CSSTransitionGroup
      transitionName={{
        appear: classes.imagesAppear,
        appearActive: classes.imagesAppearActive,
      }}
      transitionAppearTimeout={durationEnd}
      transitionAppear
    >
      <div className={classes.images}>
        <div className={classes.imgBgLeft}>
          <img src="/img/google-home-bg-left.png" alt="" />
        </div>
        <div className={classes.imgBgRight}>
          <img src="/img/google-home-bg-right.png" alt="" />
        </div>
      </div>
    </CSSTransitionGroup>
  </div>
);

Background.propTypes = {
  classes: PropTypes.shape({
    background: PropTypes.string.isRequired,
    top: PropTypes.string.isRequired,
    topAppear: PropTypes.string.isRequired,
    topAppearActive: PropTypes.string.isRequired,
    images: PropTypes.string.isRequired,
    imagesAppear: PropTypes.string.isRequired,
    imagesAppearActive: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(Background);